// ** React Imports
import { useRef, useState } from "react"
// ** Custom Components
import Wizard from "@components/wizard"
// ** Steps
import AddressInfo from "./steps-with-validation/AddressInfo"
import OtherInfo from "./steps-with-validation/OtherInfo"
import PersonalInfo from "./steps-with-validation/PersonalInfo"
import ContactInfo from "./steps-with-validation/ContactInfo"

const WizardVertical = ({ linear }) => {
  const ref = useRef(null)
  const [stepper, setStepper] = useState(null)

  const steps = [
    {
      id: "personal-info",
      title: "Personal information",
      subtitle: "Important information",
      content: <PersonalInfo stepper={stepper} type="wizard-vertical" />
    },
    {
      id: "contact-info",
      title: "Contact",
      subtitle: "Email and phone",
      content: <ContactInfo stepper={stepper} type="wizard-vertical" />
    },
    {
      id: "address-info",
      title: "Postal address",
      subtitle: "One or more addresses",
      content: <AddressInfo stepper={stepper} type="wizard-vertical" />
    },
    {
      id: "other-info",
      title: "Others",
      subtitle: "Other information",
      content: <OtherInfo stepper={stepper} type="wizard-vertical" />
    }
  ]

  return (
    <div className="vertical-wizard">
      <Wizard
        type="vertical"
        ref={ref}
        steps={steps}
        options={{ linear }}
        instance={(el) => setStepper(el)}
      />
    </div>
  )
}

export default WizardVertical
